import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/checkError-icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-5a9dedac")

_pushScopeId("data-v-5a9dedac")
const _hoisted_1 = { class: "ui__AbnormalCheck_main" }
const _hoisted_2 = { class: "ui__AbnormalCheck_body" }
const _hoisted_3 = { class: "ui__AbnormalCheck_title" }
const _hoisted_4 = {
  key: 0,
  class: "ui__AbnormalCheck_content"
}
const _hoisted_5 = { class: "ui__AbnormalCheck_content_parts" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = { class: "ui__AbnormalCheck_content_abnormalDesc" }
const _hoisted_8 = {
  key: 0,
  class: "ui__AbnormalCheck_content_abnormalImg"
}
const _hoisted_9 = {
  key: 1,
  class: "ui__AbnormalCheck_none"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, " 异常检测项 (" + _toDisplayString(_ctx.state.listSumNumber) + ") ", 1),
      (_ctx.state.defectList.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.defectList, (item) => {
              return (_openBlock(), _createBlock("div", {
                class: "ui__AbnormalCheck_content_item",
                key: item.checkItemCode
              }, [
                _createVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(item.checkItemName), 1)
                ]),
                _createVNode("div", _hoisted_7, [
                  _createVNode("pre", null, _toDisplayString(_ctx.handleSignStatus(item.signRuleVOS, item.moduleCode)), 1)
                ]),
                (item.photoList && item.photoList.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.photoList.slice(0,5), (itemp, index) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "ui__AbnormalCheck_content_abnormalImg_item",
                          key: itemp.photoIdStr
                        }, [
                          (index < 4)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: itemp.smallPhotoUrl ? itemp.smallPhotoUrl : itemp.photoPath,
                                onClick: ($event: any) => (_ctx.goPhoto(itemp))
                              }, null, 8, ["src", "onClick"]))
                            : _createCommentVNode("", true),
                          (index === 4)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                _createVNode("img", {
                                  src: itemp.smallPhotoUrl
                                }, null, 8, ["src"]),
                                _createVNode("div", {
                                  class: "ui__AbnormalCheck_content_abnormalImg_item_cover",
                                  onClick: ($event: any) => (_ctx.goPhoto(itemp, 'total'))
                                }, [
                                  _createVNode("h6", null, _toDisplayString(item.photoList.length) + "张", 1)
                                ], 8, ["onClick"])
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_9, " 检查结果无异常项 "))
    ])
  ]))
})